(function () {
  window.aliveCopyOfferCode = function (element) {
    var copied = function () {
      element.classList.add('is-copied');
      window.setTimeout(function () {
        element.classList.remove('is-copied');
      }, 1800);
    };

    var fallbackCopy = function () {
      var textarea = document.createElement('textarea');
      textarea.value = 'UNPACK10';
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand('copy');
      } catch (error) {}
      document.body.removeChild(textarea);
      copied();
    };

    if (navigator.clipboard && navigator.clipboard.writeText) {
      try {
        var copyPromise = navigator.clipboard.writeText('UNPACK10');
        if (copyPromise && copyPromise.catch) copyPromise.catch(fallbackCopy);
      } catch (error) {
        fallbackCopy();
      }
      copied();
    } else {
      fallbackCopy();
    }
  };
})();
